// extracted by mini-css-extract-plugin
export default {"mainLayout":"MainLayout_mainLayout__OnhEg","rightContent":"MainLayout_rightContent__ofrGr","contentArea":"MainLayout_contentArea__1PDMv"};